export const site = {
  name: 'Count Club',
  tagline: 'Austin',
  presentedBy: 'For ecommerce CFOs, by ecommerce CFOs',
  date: 'October 12–13, 2026',
  location: 'East Austin, TX',
  price: '$650',
  seats: 30,
  googleAnalyticsId: 'G-42VD0PZNY1',
  stripe: {
    buyButtonId: 'buy_btn_1U2s2JDJqnDYHMQe0lSPKWYV',
    publishableKey: 'pk_live_51U29zWDJqnDYHMQeboT1WP8cAae0d4TNbMTShKCMZzC0AFO8E8TnOTtIg8YvABkwwsKfpXtwZlHQdVWNqYyaYU0M00eb1Pt97X'
  },
  logoBeigeUrl: 'https://cdn.magicpatterns.com/uploads/mSrg22zjE5xCMS7zzmpfc1/Count_Club_Logo_beige.png',
  logoGreenUrl: 'https://cdn.magicpatterns.com/uploads/wEcPdHRMg9qDjiLRoGqLPy/Count_Club_Logo.webp',
  heroBgUrl: 'https://cdn.magicpatterns.com/patterns/generated-images/462929c4-f3d1-4b97-b043-eedc91104a1c.jpg',
  aboutImageUrl: 'https://cdn.magicpatterns.com/uploads/mT8o2NrQwJRYrucqvULV3f/Group_40183.webp',
  venueImageUrl: 'https://cdn.magicpatterns.com/patterns/generated-images/7c43ee9f-0a13-4379-aaf5-70c9a52948e9.jpg',
  video: {
    youtubeId: 'owobga9YRts',
    posterUrl: 'https://img.youtube.com/vi/owobga9YRts/maxresdefault.jpg',
    label: 'Watch the video',
    caption: 'A look inside the event'
  }
};
export const navLinks = [{
  label: 'About',
  href: '#about'
}, {
  label: 'Agenda',
  href: '#agenda'
}, {
  label: 'Register',
  href: '#register'
}];
export const partners = [{
  name: 'Ecom CFO',
  href: 'https://ecomcfo.co/'
}, {
  name: 'Ecom CPA',
  href: 'https://ecomcpa.com/'
}, {
  name: 'A2X',
  href: 'https://www.a2xaccounting.com/'
}, {
  name: 'Highbeam',
  href: 'https://www.highbeam.com/'
}, {
  name: 'Numeral',
  href: 'https://www.numeral.com/'
}];
export const aboutHighlights = [{
  title: 'The room',
  body: '30 finance leaders from 8 and 9 figure brands. You’ll leave knowing every name.'
}, {
  title: 'The sessions',
  body: 'Closed-door roundtables on the problems you’re actually facing: capital, forecasting, tariffs, tooling, org design, the founder relationship. Peer-led, no slides or recordings.'
}, {
  title: 'The food',
  body: 'Day 1 closes at Franklin Barbecue: private dinner, pit tour, no line.'
}];
export const reasons = [{
  title: 'Network with Leaders',
  body: 'Connect with 30 ecommerce finance leaders and CFOs facing similar growth challenges.'
}, {
  title: 'Hands-on Tools',
  body: 'Deep dive into the latest financial tech stacks with practical demos and workshops.'
}, {
  title: 'Franklin BBQ Dinner',
  body: 'Private restaurant takeover. No line required for the world-famous brisket.'
}, {
  title: 'Fireside Chat',
  body: 'Potential discussion with Aaron & Stacy Franklin on scaling a legendary business.'
}];
export type AgendaItem = {
  time: string;
  title: string;
  body?: string;
};
export type AgendaDay = {
  id: string;
  date: string;
  label: string;
  items: AgendaItem[];
};
export const agenda: AgendaDay[] = [{
  id: 'day-1',
  date: 'October 12',
  label: 'Day 1 — Sessions & Franklin',
  items: [{
    time: '8:00 AM – 9:00 AM',
    title: 'Breakfast & Networking'
  }, {
    time: '9:00 AM – 9:30 AM',
    title: 'Intro Session & Agenda',
    body: 'Guiding principles, who’s in the room, what to expect, and how we’ll learn from each other — including how we’re approaching AI.'
  }, {
    time: '9:30 AM – 10:30 AM',
    title: 'State of DTC & the Consumer',
    body: 'A macroeconomic overview of where the consumer and DTC stand today.'
  }, {
    time: '10:30 AM – 12:00 PM',
    title: 'The Office of the CFO Today',
    body: 'How we define the office of the CFO, how it’s changing, and its relationship to the business — where IT and HR live, with live benchmarking from the room.'
  }, {
    time: '12:00 PM – 1:30 PM',
    title: 'Lunch'
  }, {
    time: '1:30 PM – 2:30 PM',
    title: 'Tom Gould: Tariffs & Supply Chain',
    body: 'Navigating tariffs, supply chain shifts, and what they mean for your P&L.'
  }, {
    time: '2:30 PM – 2:45 PM',
    title: 'Roundtables & Mastermind: How It Works',
    body: 'A quick tactical overview before we break into tables.'
  }, {
    time: '2:45 PM – 4:00 PM',
    title: 'Roundtables & Mastermind',
    body: 'Four tables of five, mixing brand CFOs with fractional CFOs. Rotating so everyone meets everyone.'
  }, {
    time: '4:00 PM – 6:00 PM',
    title: 'Free Time'
  }, {
    time: '6:00 PM',
    title: 'The Franklin Barbecue Experience',
    body: 'Private dinner, pit tour, no line.'
  }]
}, {
  id: 'day-2',
  date: 'October 13',
  label: 'Day 2 — Masterminds & Benchmarks',
  items: [{
    time: '7:30 AM – 8:30 AM',
    title: 'Optional Town Lake Run'
  }, {
    time: '8:30 AM – 9:30 AM',
    title: 'Breakfast & Networking'
  }, {
    time: '9:30 AM – 10:00 AM',
    title: 'Day One Recap & Day Two Overview',
    body: 'A few attendees share their biggest learnings from Day One.'
  }, {
    time: '10:00 AM – 12:00 PM',
    title: 'Roundtables & Mastermind, Continued'
  }, {
    time: '12:00 PM – 1:30 PM',
    title: 'Lunch'
  }, {
    time: '1:30 PM – 2:00 PM',
    title: 'Roundtable & Mastermind Readout'
  }, {
    time: '2:00 PM – 3:00 PM',
    title: 'Tools & Software Pulse: Lightning Round',
    body: 'Favorites and landmines across sales tax, IMS, banking, GLs, FP&A, ERP, treasury, cash flow forecasting, AI tools, and financing — from SBA to alternative lending. Rated live by the room.'
  }, {
    time: '3:00 PM – 4:00 PM',
    title: 'Ecom CFO Benchmarks',
    body: 'Ecom CFO and fellow fractional CFOs share what good looks like, with live benchmarking and the benchmarks you want to see.'
  }, {
    time: '4:00 PM – 4:15 PM',
    title: 'Close'
  }]
}];
export const venueBullets = ['Private restaurant takeover — no line required', 'Full menu of brisket, ribs, and sides', 'Local craft beers and drinks included', 'Potential fireside chat with Aaron & Stacy Franklin'];
export const included = ['Two days of workshops & sessions', 'Breakfast, lunch & snacks', 'Private dinner at Franklin BBQ', 'Networking with 30 CFOs'];